import React, { useMemo } from "react";
import { ContactGroupDropdownProps } from "./types";

import { MultiDropdownOption } from "../MultiDropdown/types";
import { getContactGroupsAPI } from "services/api/contacts/api";
import { DataWithPagination } from "services/api";
import { initialDataWithPagination } from "services/api/consts";
import { ContactGroupRow } from "services/api/contacts/types";
import MultiDropdown from "../MultiDropdown/MultiDropdown";
import { DropdownCacheKey, buildDropdownCacheKey, useDropdownCache } from "services/hooks/useDropdownCache";

const FIVE_MINUTES = 5 * 60 * 1000;

const ContactGroupDropdown: React.FC<ContactGroupDropdownProps> = (
  props: ContactGroupDropdownProps
) => {
  const {
    name,
    disabled,
    required,
    label,
    error,
    value,
    direction,
    width,
    height,
    placeholder,
    contactTypeId,
    onChange,
  } = props;

  const { data } = useDropdownCache<DataWithPagination<ContactGroupRow>>(
    buildDropdownCacheKey(DropdownCacheKey.ContactGroups, contactTypeId),
    () => getContactGroupsAPI(initialDataWithPagination.pagination, null, contactTypeId),
    FIVE_MINUTES
  );

  const contactGroupItems: MultiDropdownOption[] = useMemo(
    () => (data?.data ?? []).map((i) => ({
      value: i.id,
      text: `${i.name}`,
    })),
    [data]
  );

  return (
    <MultiDropdown
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      value={value}
      direction={direction}
      width={width}
      height={height}
      options={contactGroupItems}
      onChange={onChange}
      error={error}
    />
  );
};

export default React.memo(ContactGroupDropdown);
